var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{key:JSON.stringify(_vm.renderData),staticClass:"phtContent"},_vm._l((_vm.renderData),function(paragraph,rindex){return _c('div',{key:rindex,staticClass:"normal_pht",style:({ 'justify-content': _vm.baseStyles.justifyContent })},_vm._l((paragraph),function(item,index){return _c('div',{key:JSON.stringify(item) + index,class:[
        'pht_single',
        item.text && _vm.showPinyin && item.pinyin
          ? 'pht_single_pinyin'
          : 'pht_single_text',
      ],style:({
        ..._vm.writingSpacing,
        textIndent: _vm.baseStyles.hasIndent || '',
        marginLeft:
          (item.text === '空' && item.margin && item.isMargin) ? _vm.wordSpacing:(
            item.margin || _vm.type === 'hasTian' || index === 0
            ? '0px'
            : item.pinyin
            ? _vm.wordSpacing
            : '0px'
          ),
      })},[(item.blank === 'input' && !_vm.ifSet)?[_c('div',{staticClass:"pht_input"},[_c('div',{staticClass:"pht_input_box",style:({ borderColor: item.color })},[_c('input',{key:_vm.blankInput[item.inputIndex],ref:`input${item.inputIndex}`,refInFor:true,staticClass:"pht_input_blank",style:({ width: item.inputWidth, color: item.color }),attrs:{"type":"text","maxlength":parseInt(item.width),"disabled":_vm.inputMode != 1},domProps:{"value":_vm.blankInput[item.inputIndex]},on:{"change":function($event){return _vm.inputChange($event, item)}}}),_c('img',{directives:[{name:"show",rawName:"v-show",value:(_vm.inputMode == '1' && !_vm.blankInput[item.inputIndex]),expression:"inputMode == '1' && !blankInput[item.inputIndex]"}],staticClass:"pht_input_img",attrs:{"src":require("../../../../assets/images/edit_input.png")},on:{"click":function($event){return _vm.clickInputImg(item.inputIndex)}}})]),(item.pinyin)?_c('p',{staticStyle:{"font-family":"'pinyinFont'"}},[_vm._v("（"+_vm._s(item.pinyin)+"）")]):_vm._e()])]:(item.blank === 'input' && _vm.ifSet)?[_c('div',{staticClass:"pht_set_input"},[_vm._v(" "+_vm._s(_vm.questionIndex + item.inputCount)+" ")])]:(_vm.onlyPinyin)?[(item.text && _vm.showPinyin && item.pinyin)?_c('p',{staticClass:"pinyin",style:(_vm.isEssay && index === 0 ? _vm.titlePinyinStyle : _vm.hzStyle)},[(_vm.evalXml)?_c('span',[_c('span',{style:({
                color: _vm.evalXml ? (item.sheng ? '#06CA9F' : '#EB5564') : '',
              })},[_vm._v(_vm._s(item.shengmu))]),_c('span',{style:({
                color: _vm.evalXml ? (item.yun ? '#06CA9F' : '#EB5564') : '',
              })},[_vm._v(_vm._s(item.yunmu))])]):_vm._e(),(!_vm.evalXml && item.text.length === 1)?_c('span',{style:({
              color: item.color,
            })},[_vm._v(_vm._s(item.pinyin))]):_vm._e(),(!_vm.evalXml && item.text.length > 1)?_c('span',[_c('span',{style:({ color: item.color })},[_vm._v(_vm._s(item.pinyin.slice(0, -1)))]),_c('span',{style:({ color: item.color2 })},[_vm._v(_vm._s(item.pinyin[item.pinyin.length - 1]))])]):_vm._e()]):_vm._e()]:[(item.blank === 'underline')?_c('div',{staticClass:"underline",style:({
            width: (item.width ? item.width : 2) * 30 + 'px',
            height: '100%',
            borderBottom: '1px solid rgba(73,79,90,1)',
            textAlign: 'center',
          })},[_vm._v(" "+_vm._s(item.text)+" ")]):_vm._e(),(item.text && _vm.showPinyin && item.pinyin)?_c('p',{staticClass:"pinyin",style:(_vm.isEssay && index === 0 ? _vm.titlePinyinStyle : _vm.pinyinStyle)},[(_vm.evalXml)?_c('span',[_c('span',{style:({
                color: _vm.evalXml ? (item.sheng ? '#06CA9F' : '#EB5564') : '',
              })},[_vm._v(_vm._s(item.shengmu))]),_c('span',{style:({
                color: _vm.evalXml ? (item.yun ? '#06CA9F' : '#EB5564') : '',
              })},[_vm._v(_vm._s(item.yunmu))])]):_vm._e(),(!_vm.evalXml && item.text.length === 1)?_c('span',{style:({
              color: item.color,
            })},[_vm._v(_vm._s(item.pinyin))]):_vm._e(),(!_vm.evalXml && item.text.length > 1)?_c('span',[_c('span',{style:({ color: item.color })},[_vm._v(_vm._s(item.pinyin.slice(0, -1)))]),_c('span',{style:({ color: item.color2 })},[_vm._v(_vm._s(item.pinyin[item.pinyin.length - 1]))])]):_vm._e()]):_vm._e(),(item.blank != 'underline' && _vm.type === 'normal')?_c('p',{staticClass:"hz",style:(_vm.isEssay && index === 0 ? _vm.titleHzStyle : _vm.hzStyle)},[(item.blank!='space')?[_vm._v(_vm._s(item.blank))]:_vm._e(),(item.type === 'string')?_c('span',{style:({
              color: _vm.evalXml
                ? item.syll
                  ? '#06CA9F'
                  : '#EB5564'
                : item.color,
              marginTop:
                _vm.showPinyin && !item.pinyin ? _vm.pinyinStyle.lineHeight : '0px',
            })},_vm._l((item.text),function(ii,index){return _c('span',{key:ii + index,style:(!ii||ii==' ' ? 'min-width:14px;display:inline-block;':'', {'display':ii == '\n' ? 'block' :''})},[_vm._v(_vm._s(ii === " " ? ii.replace(/\s/g,'  ') : ii))])}),0):(item.type==='stringTag')?_c('span',{staticClass:"string-tag",style:({
              color: _vm.evalXml
                ? item.syll
                  ? '#06CA9F'
                  : '#EB5564'
                : item.color,
              marginTop:
                _vm.showPinyin && !item.pinyin ? _vm.pinyinStyle.lineHeight : '0px',
            }),domProps:{"innerHTML":_vm._s(item.text)}}):(item.text===' ')?_c('span',{staticStyle:{"min-width":"8px","display":"inline-block"}},[_vm._v(_vm._s(item.text))]):(item.text.length === 1)?_c('span',{style:({
              color: _vm.evalXml
                ? item.syll
                  ? '#06CA9F'
                  : '#EB5564'
                : item.color,
              marginTop:
                _vm.showPinyin && !item.pinyin ? _vm.pinyinStyle.lineHeight : '0px',
              visibility: !!item.space ? 'hidden' : 'visible',
            })},[_vm._v(_vm._s(item.text))]):(item.text.length === 2)?_c('span',{style:({
              color: _vm.evalXml
                ? item.syll
                  ? '#06CA9F'
                  : '#EB5564'
                : item.color,
              marginTop:
                _vm.showPinyin && !item.pinyin ? _vm.pinyinStyle.lineHeight : '0px',
            })},[_c('span',{style:({ color: item.color })},[_vm._v(_vm._s(item.text[0]))]),_c('span',{style:({ color: item.color2 || item.color })},[_vm._v(_vm._s(item.text[1]))])]):_c('span',{style:({
              color: item.color,
              marginTop:
                _vm.showPinyin && !item.pinyin ? _vm.pinyinStyle.lineHeight : '0px',
            })},[_vm._v(_vm._s(item.text))])],2):_vm._e(),(_vm.type === 'hasTian' && item.text)?_c('div',{staticClass:"tianBox",style:(_vm.tianBoxStyle)},[(item.text.length === 1)?_c('p',{staticClass:"t_hz",style:(_vm.hzStyle)},[_c('span',{style:({
                color:
                  item.pinyin && _vm.evalXml
                    ? item.syll
                      ? '#06CA9F'
                      : '#EB5564'
                    : item.color,
              })},[_vm._v(_vm._s(item.text))])]):(item.text.length === 2)?_c('p',{staticClass:"t_hz"},_vm._l((item.text.split('')),function(hzItem){return _c('span',{key:hzItem,style:({
                ...(hzItem === '儿'
                  ? _vm.half_subordinate_hzStyle
                  : _vm.half_main_hzStyle),
                color: hzItem === '儿' ? item.color2 : item.color,
              })},[_vm._v(_vm._s(hzItem))])}),0):(item.text.length === 3)?_c('p',{staticClass:"t_hz",style:(_vm.hzStyle)},[_c('span',{style:({
                color:
                  item.pinyin && _vm.evalXml
                    ? item.syll
                      ? '#06CA9F'
                      : '#EB5564'
                    : item.color,
                'letter-spacing':
                  '-' +
                  (Number(_vm.baseStyles.hzFontSize.split('px')[0]) * 4) / 5 +
                  'px',
                'margin-left':
                  '-' +
                  (Number(_vm.baseStyles.hzFontSize.split('px')[0]) * 4) / 5 +
                  'px',
              })},[_vm._v(_vm._s(item.text))])]):_vm._e()]):_vm._e()]],2)}),0)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }